export class AssignedToUserDto{
    public UserId: number | undefined
    public Name: string | undefined
} 